import TermCreateEdit from "../AdminTermCreateEdit";

export default class AdminTermCreateEditDistributionType extends TermCreateEdit {
    /**
     * @returns {string} The term type.
     */
    getType() {
        return 'distribution_type';
    }
}
